import clsx from 'clsx'

import styles from './icon.module.css'
import type { IconDefaultProps } from './types'

const CalendarDay = ({ className }: IconDefaultProps): JSX.Element => (
  <svg
    className={clsx(styles.icon, className)}
    viewBox='0 0 21 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path d='M4.25 10.3125C4.25 9.45312 4.91406 8.75 5.8125 8.75H8.9375C9.79688 8.75 10.5 9.45312 10.5 10.3125V13.4375C10.5 14.3359 9.79688 15 8.9375 15H5.8125C4.91406 15 4.25 14.3359 4.25 13.4375V10.3125ZM5.5 10.3125V13.4375C5.5 13.6328 5.61719 13.75 5.8125 13.75H8.9375C9.09375 13.75 9.25 13.6328 9.25 13.4375V10.3125C9.25 10.1562 9.09375 10 8.9375 10H5.8125C5.61719 10 5.5 10.1562 5.5 10.3125ZM6.75 2.5H14.25V0.625C14.25 0.3125 14.5234 0 14.875 0C15.1875 0 15.5 0.3125 15.5 0.625V2.5H16.75C18.1172 2.5 19.25 3.63281 19.25 5V17.5C19.25 18.9062 18.1172 20 16.75 20H4.25C2.84375 20 1.75 18.9062 1.75 17.5V5C1.75 3.63281 2.84375 2.5 4.25 2.5H5.5V0.625C5.5 0.3125 5.77344 0 6.125 0C6.4375 0 6.75 0.3125 6.75 0.625V2.5ZM3 17.5C3 18.2031 3.54688 18.75 4.25 18.75H16.75C17.4141 18.75 18 18.2031 18 17.5V7.5H3V17.5ZM3 5V6.25H18V5C18 4.33594 17.4141 3.75 16.75 3.75H4.25C3.54688 3.75 3 4.33594 3 5Z' />
  </svg>
)

export default CalendarDay
